import React from "react";
import Esports from "./Esports";
import SportsDraft from "./SportsDraft";
import Saas from "./Saas";
import CasualGames from "./Casualgames";
import Clients from "./Clients";
import Numbers from "./Number";
import Blogs from "./Blogs";
import PRlinks from "./Prlinks";
import Footer from "../common/Footer";
import Banner from "./banner";
import Header from "../common/header";
const PRLinksOnClick = () => {
   

    return (
        <div className="w-full h-full">
            <Header />

            <Banner />
            {/* <Esports />
            <SportsDraft />
            <Saas />
            <CasualGames />
            <Numbers />
            <Clients />
            <PRlinks />
            <Blogs /> */}
            <Footer />
        </div>

    );
};

export default PRLinksOnClick;
